import axios from "axios";
import { Config } from "../Config";
import { userAccessToken } from "../helpers";
export const handelSupport = (data) => {
  try {
    const response = axios.post(
      `${Config.apiServerUrl}/support/create-support`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const fetchAllSupports = () => {
  try {
    const response =  axios.get(
    `${Config.apiServerUrl}/support/all-supports`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
    return response;
  }catch (error){
    return error?.response?.data;
  }
};

export const fetchFilterSupports = (filter) => {
  const {
    account_id, 
    location_id,
    page,
    per_page,
    order_by
  } = filter;
  let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
  try {
    const response =  axios.get(
    `${Config.apiServerUrl}/support/filter-supports?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${orderBy}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
    return response;
  }catch (error){
    return error?.response?.data;
  }
};

export const updateSupportStatus = (statusData) => {
  
  try {
    const response =  axios.patch(
    `${Config.apiServerUrl}/support/update-support-status`,statusData,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
    return response;
  }catch (error){
    return error?.response?.data;
  }
};


export const fetchAllSupportMessages = async (account_id, location_id, case_id, last_fetch_id) => {

  try {
    const fetchId = last_fetch_id ? `&last_fetch_id=${last_fetch_id}` : "";
    
    const response = await axios.get(
      `${Config.apiServerUrl}/support/messages?account_id=${account_id}&location_id=${location_id}&case_id=${case_id}${fetchId}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};


export const handelSupportMessage = (data) => {
  try {
    const response = axios.post(
      `${Config.apiServerUrl}/support/create-support-message`, data,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    return error?.response?.data;
  }
};